import React, { Component } from 'react'
import { CloseCircleOutlined } from '@ant-design/icons'
import { Input, Button, Tooltip } from 'hljd'
import { Upload, PreviewModal } from 'hlj-components'
import { inject, observer } from 'mobx-react'
import Style from './style.module.less'

const TextArea = Input.TextArea

@inject('store')
@observer
export default class extends Component {
  render() {
    const { chatStore } = this.props.store
    const {
      chatMsg,
      chatImages,
      changeChatMsg,
      sendChatMsg,
      changeCouponModalVisable,
      changeCashModalVisible,
      onCliped,
      deleteChatImg
    } = chatStore

    return (
      <div className={Style['chat-input']}>
        <p className={Style.title}>主播说</p>
        <div className={Style['group']}>
          <div className={Style['imgs']}>
            {chatImages.map((item, index) => {
              return (
                <div className={Style['imgs-item']} key={index}>
                  <img
                    onClick={() =>
                      PreviewModal.open({ children: <img src={item.path} /> })
                    }
                    src={`${item.path}?imageView2/1/w/50/h/50`}
                  />
                  <CloseCircleOutlined
                    className={Style['imgs-item-icon']}
                    onClick={deleteChatImg(index)}
                  />
                </div>
              )
            })}
          </div>
          <TextArea
            placeholder="请输入内容"
            value={chatMsg}
            onChange={changeChatMsg}
          />
          <Button type="primary" onClick={sendChatMsg}>
            发送
          </Button>
        </div>
        <div className={Style['icons']}>
          <Upload
            autoSizeError={true}
            max_file_size="10mb"
            onOk={onCliped}
            multiple={true}
            filters={{
              mime_types: [
                {
                  title: 'images files',
                  extensions: 'jpg,gif,png,jpeg,bmp'
                }
              ],
              max_file_size: '10mb'
            }}
          >
            <img
              className={Style['icons-img']}
              src="https://qnm.hunliji.com/o_1d9jjp0qf6upqdf1iq31bkf1ifvk.png"
            />
          </Upload>
          <img
            onClick={changeCouponModalVisable}
            className={Style['icons-img']}
            src="https://qnm.hunliji.com/o_1d9jjp0qf1cbq1fg189sptv1i3ll.png"
          />
          <Tooltip
            arrowPointAtCenter
            overlayClassName={Style['popover-cash']}
            text
            placement="topLeft"
            title={'新增红包功能'}
            getPopupContainer={trigger => trigger.parentNode}
          >
            <img
              onClick={changeCashModalVisible}
              className={Style['icons-img']}
              style={{ marginRight: 0, width: 16 }}
              src="https://qnm.hunliji.com/o_1dkf54eha1t45c721n4ica51e5ej.png"
            />
          </Tooltip>
        </div>
      </div>
    )
  }
}
